module.exports = __webpack_public_path__ + "static/img/2.8ddb26a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/7/sp/2.png
// module id = uoL7
// module chunks = 0